export default "__VITE_ASSET__bQnthjf0__"